import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/pages/Login';
import ForgotPassword from './components/pages/ForgotPassword';
import Register from './components/pages/Register';
import InfoAccess from './components/pages/InfoAccess';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './components/molecules/ErrorFallback';
import { AuthProvider } from './services/context/AuthContext';
import { addReactError } from '@datadog/browser-rum-react';

console.log(`version: ${window.env?.REACT_APP_VERSION}`);

function Router() {
  return (
    <AuthProvider>
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={addReactError}>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/info-access' element={<InfoAccess />} />
            <Route path='/register' element={<Register />} />
            <Route path='/forgot-password' element={<ForgotPassword />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </AuthProvider>
  );
}

export default Router;
